import { datadogRum } from '@datadog/browser-rum-slim';
const INIT_DEFAULTS = {
    actionNameAttribute: 'track-action-name',
};
export const datadogRumIntegration = (config) => ({
    addError(error, context = {}) {
        datadogRum.addError(error, context);
    },
    init() {
        datadogRum.init({ ...INIT_DEFAULTS, ...config });
    },
    clearUser() {
        datadogRum.clearUser();
    },
    setContext(key, value) {
        datadogRum.setGlobalContextProperty(key, value);
    },
    setUser(user) {
        const rumUser = { ...user, id: `${user.id}` };
        datadogRum.setUser(rumUser);
    },
    addAction(actionName, context = {}) {
        datadogRum.addAction(actionName, context);
    },
    setRouteName(name) {
        datadogRum.startView(name);
    },
    addTiming(name, time) {
        datadogRum.addTiming(name, time);
    },
});
//# sourceMappingURL=index.js.map